import React from 'react'
import { AdjustmentsHorizontalIcon, ArrowPathIcon } from '@heroicons/react/24/outline'
import Card from '../ui/Card'
import Badge from '../ui/Badge'
import Button from '../ui/Button'
import { projects, wpsSummaries } from '../../data/dummyData'

export default function WpsLibrary() {
  return (
    <div className="space-y-6">
      <Card title="WPS Library" action={<Button variant="secondary"><ArrowPathIcon className="h-4 w-4 mr-2" />Sync</Button>}>
        <div className="grid gap-4 lg:grid-cols-4">
          <div>
            <label className="text-xs font-medium text-gray-500">Project</label>
            <select className="input-primary mt-1">
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500">Process</label>
            <select className="input-primary mt-1">
              <option>All</option>
              <option>GMAW</option>
              <option>FCAW</option>
              <option>GTAW</option>
              <option>SMAW</option>
              <option>SAW</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500">Status</label>
            <select className="input-primary mt-1">
              <option>All</option>
              <option>Draft</option>
              <option>Review</option>
              <option>Approved</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500">Quick filters</label>
            <Button variant="secondary" className="mt-2 w-full justify-center">
              <AdjustmentsHorizontalIcon className="h-4 w-4 mr-2" />
              Thickness & Joint
            </Button>
          </div>
        </div>
      </Card>

      <Card title="WPS Results">
        <div className="overflow-x-auto">
          <table className="table">
            <thead className="table-header">
              <tr>
                <th>WPS Number</th>
                <th>Status</th>
                <th>Process</th>
                <th>Base Material</th>
                <th>Thickness</th>
                <th>Joint</th>
                <th>Position</th>
                <th>Revision</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {wpsSummaries.map((wps) => (
                <tr key={wps.id}>
                  <td className="font-medium text-primary-700">{wps.number}</td>
                  <td>
                    <Badge tone={wps.status === 'Approved' ? 'success' : wps.status === 'Review' ? 'warning' : 'gray'}>
                      {wps.status}
                    </Badge>
                  </td>
                  <td>{wps.process}</td>
                  <td>{wps.baseMaterial}</td>
                  <td>{wps.thicknessRange}</td>
                  <td>{wps.jointType}</td>
                  <td>{wps.position}</td>
                  <td>{wps.revision}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  )
}
